module.exports = __webpack_public_path__ + "img/tooltip_beta.3446faa.svg";